import { render } from "./HeroArea.vue?vue&type=template&id=7296840b&scoped=true"
import script from "./HeroArea.vue?vue&type=script&lang=js"
export * from "./HeroArea.vue?vue&type=script&lang=js"

import "./HeroArea.vue?vue&type=style&index=0&id=7296840b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7296840b"]])

export default __exports__